/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <section class="sort-filter-section">
    <div class="sort-filter-section_wrapper">
      <b-row no-gutters class="align-items-center">
        <b-col cols="8" offset="4" class="d-flex align-items-center justify-content-end">
          <!-- FILTER -->
          <filter-selected @changeFilter="$emit('changeFilter', $event)" />
          <div class="wrapp-filters wrapp-block-filter">
            <button class="section-filter btn btn-icon btn-icon-medium btn-icon-border-black btn-rounded" @click="toggleFilter(true)">
              <svg class="o-icon fill-black"><use xlink:href="#filters"></use></svg>
            </button>
          </div>
        </b-col>
      </b-row>
    </div>
    <listing-modal-filters :filtersAvailable="filtersAvailable" v-model="toggleModalFilters" @close="toggleFilter" @changeFilter="applyFilters" />
  </section>
</template>

<script>
import FilterSelected from './FilterSelected'
import ListingModalFilters from 'theme/components/Modal/ListingModalFilters'

export default {
  props: ['currentCategory', 'subCategoryVisible', 'sort'],
  data () {
    return {
      toggleModalFilters: false
    }
  },
  computed: {
    listingColumns () {
      return this.$store.getters['ui/getListingColumns']
    },
    filtersAvailable () {
      return this.$store.state.listing.filters.available
    }
  },
  methods: {
    toggleFilter ($event) {
      this.toggleModalFilters = $event
    },
    applyFilters () {
      this.scrollToTop()
      return this.$emit('changeFilter')
    },
    clearFilters () {
      this.resetFiltersInDrop()
      this.scrollToTop()
      this.$store.commit('listing/clearFilters')
      return this.$emit('changeFilter')
    },
    resetFiltersInDrop () {
      // All filters are inside an unique dropdown
      // access to each child of the drop to reset activeFilter
      let $childrens = this.$refs.filterDropdown.$children
      for (let i in $childrens) {
        $childrens[i].clearFilter()
      }
      return true
    },
    scrollToTop () {
      window.pagePosition = undefined
    }
  },
  mounted () {
    if (process.client && window.sessionStorage) {
      // check if localstorage has default column setted
      let hasColumnsSetted = window.localStorage.getItem('listingColumns')
      if (!hasColumnsSetted) {
        // set layout at 2 column by default
        return this.$store.commit('ui/setListingColumns', 2)
      }
    }
  },
  components: {
    FilterSelected,
    ListingModalFilters
  }
}
</script>
